import React, { useState, useEffect } from "react";
import axios from "axios";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";
import { addThousandPoint, removeThousandPoint } from "../../../components/common/Common";

const TextBooksDetail = ({varShowDetail,setShowDetail,varTextBooksIndex,GetTextBooksList}) => {
  
  //교재정보
  const [varTextBooksInfo,setTextBooksInfo] = useState({});

  //교재정보 읽어오기
  const GetTextBooksInformation = async () => {
    const sendData = {mode:5,vidx:varTextBooksIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_variable_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          setTextBooksInfo(dataInfo);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    //교재 정보
    if(varTextBooksIndex === 0){
      const variableState = {vb_idx:0,vb_vt_mode:0,vb_vt_name:"",vb_price:0,vb_status:1};
      setTextBooksInfo(variableState);
    } else {
      GetTextBooksInformation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varTextBooksIndex]);

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "vb_price") {
      setTextBooksInfo({...varTextBooksInfo,[name]:removeThousandPoint(value)});
    } else if(name === "vb_vt_mode") {
      setTextBooksInfo({...varTextBooksInfo,[name]:Number(value)});
    } else {
      setTextBooksInfo({...varTextBooksInfo,[name]:value});
    }
  }

  //교재 저장
  const onUpdateTextBooksHandler = async (e) => {
    if(varTextBooksInfo.vb_name === "") {
      alert('변수명을 먼저 입력하세요.'); return false;
    }

    if(!window.confirm('변수명을 저장합니까?')) return false;

    const sendData = {mode:5,vidx:varTextBooksIndex,dataInfo:varTextBooksInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_variable_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        setShowDetail(false);
        GetTextBooksList();
      }
    });
  }

  return (
    <div className="admin-content"style={varShowDetail?{display:""}:{display:"none"}}>
      <div className="main-box">
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="30%"/><col width="70%"/></colgroup>
          <thead></thead>
          <tbody>
            <tr>
              <th>과목</th>
              <td>
                <input type="radio" name="vb_vt_mode" id="vb_vt_mode1" value={1} checked={varTextBooksInfo.vb_vt_mode===1} onChange={(e)=>onChangeInputHandler(e)}/>
                <label htmlFor={'vb_vt_mode1'}>수/연산</label>
                <input type="radio" name="vb_vt_mode" id="vb_vt_mode2" value={2} checked={varTextBooksInfo.vb_vt_mode===2} onChange={(e)=>onChangeInputHandler(e)}/>
                <label htmlFor={'vb_vt_mode2'}>감각/기하</label>
              </td>
            </tr>
            <tr>
              <th>단계</th>
              <td><input type="text" className="w_s_input" name="vb_vt_name" value={varTextBooksInfo.vb_vt_name||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>가격</th>
              <td><input type="text" className="w_s_input" name="vb_price" value={addThousandPoint(varTextBooksInfo.vb_price)||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-center" style={{marginBottom:"20px"}}>
        <button onClick={(e)=>onUpdateTextBooksHandler(e)} style={{width:"90px"}} className="btn">저장</button>
        <button onClick={()=>setShowDetail(false)} style={{width:"90px"}} className="btn line">닫기</button>
      </div>
    </div>
  );
}
export default TextBooksDetail;